<template>
  <div class="group_stage">
    <h2 class="title">{{score_list.name}}</h2>
    <div class="group_list">
      <p class="mess_top">最多选择竞猜{{score_list.item_limite}}场比赛</p>
      <template v-for="item in groups">
        <div class="group_item">
          <p class="p_title"> {{item.name1}} VS {{item.name2}} </p>
          <p class="summary" v-for="item2,index in item.item_name">
            <input class="comm_radio"
                   @change="storageCheck(item.id,index,item2.mess,item.name1,item.name2)"
                   :name="item.id" :checked="item2.isCheck" :value="item2.mess"
                   @click="controlSingel($event,item.id,index)"
                   type="radio"><span>{{item2.mess}}</span>
          </p>
        </div>
      </template>
    </div>
    <template v-if="!score_list.result">
      <div class="sel_list addmargin">
        <span>获取方式：</span>
        <select class="select_title comm_sel" @change="changeGetOption()" v-model="options">
          <option value="现场领取">现场领取</option>
          <option value="邮寄">邮寄</option>
        </select>
      </div>
      <div class="address_box" v-if="is_option">
        <div class="input_box">
          <span>收件人：</span>
          <div class="ins">
            <input class="comm_input" placeholder="收件人" type="text" v-model="input_val1"/>
          </div>
        </div>
        <div class="input_box">
          <span>联系方式：</span>
          <div class="ins">
            <input class="comm_input" placeholder="手机号" type="text" v-model="input_val2"/>
          </div>
        </div>
        <div class="input_box">
          <span>邮寄地址：</span>
          <div class="ins">
            <input class="comm_input" placeholder="邮寄地址" type="text" v-model="input_val3"/>
          </div>
        </div>
      </div>
      <p class="mess_bottom" v-if="!is_option">{{score_list.self_take}}</p>

      <button class="sub_btn"
              :disabled="score_list.guess_count>=score_list.limite_guess_count || score_list.is_over_time==1"
              @click="subMess">{{score_list.is_over_time==1? '竞猜已结束' : '提交'}}
      </button>
    </template>
    <template v-if="score_list.result">
      <button class="sub_btn" disabled="true">您的竞猜结果是：{{score_list.result}}</button>
    </template>
  </div>
</template>

<script>


    export default {
        name: "GroupStage",
        props: {
            score_list: {},
            tab_list: {}
        },
        data() {
            return {
                tablist1: '',
                tablist2: '',
                value1: '',
                value2: '',
                is_option: true,
                input_val1: '',
                input_val2: '',
                input_val3: '',
                options: '邮寄',
                group_s: [],
                group_radio: 1,
                mess_list: []
            }
        },
        computed: {
            result() {
                let arrs=[]
                let str=''
                this.mess_list.map((v,i)=>{
                    let strs = {mess:v.group1+'VS'+v.group2,scores:v.score}
                    arrs.push(strs);
                })
                for (let i=0;i<arrs.length;i++){
                    str =str + arrs[i].mess+':'+arrs[i].scores+','
                }
                return str;
            },
            address() {
                return '收件人：'+this.input_val1+',联系方式'+this.input_val2+',邮寄地址：'+this.input_val3
            },
            groups() {
                for (let i = 0; i < this.tab_list.length; i++) {
                    let group_ass1 = {}
                    group_ass1.name1 = this.tab_list[i].name.split('|')[0];
                    group_ass1.name2 = this.tab_list[i].name.split('|')[1];
                    group_ass1.id = this.tab_list[i].id;
                    group_ass1.item_name = [{
                        mess: group_ass1.name1 + '胜',
                        isCheck: false
                    }, {
                        mess: group_ass1.name2 + '胜',
                        isCheck: false
                    }, {mess: '平局', isCheck: false}];
                    this.group_s.push(group_ass1);
                }
                console.log(this.group_s)
                return this.group_s
            },
        },
        watch: {
            tab_list: function (newValue) {
                this.tablist1 = newValue[0].name;
                this.tablist2 = newValue[1].name;
                return this.tablist1 + this.tablist2
            }
        },
        methods: {
            controlSingel($event,id, index) {
                let _this = this;
                window.setTimeout(() => {
                    if (!this.changed) {
                        $event.target.checked = false

                        for(let i=0; i<this.mess_list.length; i++) {
                            if(this.mess_list[i].id == id) {
                                this.mess_list.splice(i, 1);
                                break;
                            }
                        }

                    }
                    // console.log(this.mess_list);
                    _this.changed = false;
                    // console.log(this.result);
                }, 0);


            },
            storageCheck(id, index, score,group1,group2) {
                this.changed = true;
                let temp = {id: id, index: index, score: score,group1:group1,group2:group2};
                this.mess_list.map((v, i) => {
                    if (v.id === id) {
                        this.mess_list.splice(i, 1)
                    }
                })
                this.mess_list.push(temp);
                console.log(this.result);
            },
            subMess() {
                if (this.options == '邮寄') {

                    if (this.input_val1 != '' && this.input_val2 != '' && this.input_val3 != '') {
                        if (this.mess_list.length != this.score_list.item_limite ){
                            // console.log(this.mess_list.length)
                            alert('请选择'+this.score_list.item_limite+'场比赛');
                            return
                        }
                        this.$axios({
                            url: 'https://api.hainanfa.org.cn/guess/Submite',
                            method: 'post',
                            params: {
                                item_id: this.score_list.id,
                                result: encodeURI(this.result),
                                match_id: this.score_list.match_id,
                                user_id: localStorage.getItem("id"),
                                email_address: encodeURI(this.address)
                            },
                            headers: {
                                'Content-Type': 'application/json;charset=utf-8'
                            }
                        }).then(res => {
                            console.log(res)
                            if (res.data.status == 0) {
                                alert('提交成功')
                                this.$router.push({path: 'list'})
                            }
                            if (res.data.status == 400002) {
                                alert('您已经竞猜过了，看看别的吧')
                                this.$router.push({path: 'list'})
                            }

                        }).catch(err => {
                            console.log(err)
                        })
                    } else {
                        console.log(this.input_val1, this.input_val2, this.input_val3)
                        alert('请填写好您的信息')
                    }
                } else {
                    if (this.mess_list.length != this.score_list.item_limite ){
                        // console.log(this.mess_list.length)
                        alert('请选择'+this.score_list.item_limite+'场比赛');
                        return
                    }
                    this.$axios({
                        url: 'https://api.hainanfa.org.cn/guess/Submite',
                        method: 'post',
                        params: {
                            item_id: this.score_list.id,
                            result: encodeURI(this.result),
                            match_id: this.score_list.match_id,
                            user_id: localStorage.getItem("id"),
                            email_address: encodeURI('用户现场自取')
                        },
                        headers: {
                            'Content-Type': 'application/json;charset=utf-8'
                        }
                    }).then(res => {
                        console.log(res)
                        if (res.data.status == 0) {
                            alert('提交成功')
                            this.$router.push({path: 'list'})
                        }
                        if (res.data.status == 400002) {
                            alert('您已经竞猜过了，看看别的吧')
                            this.$router.push({path: 'list'})
                        }

                    }).catch(err => {
                        console.log(err)
                    })
                }

            },
            changeGetOption() {
                this.is_option = !this.is_option;
                console.log(this.score_list)
            }
        }
    }
</script>

<style scoped>
  .title {
    font-size: 22px;
    font-weight: bold;
    color: #000000;
    line-height: 1.5;
  }

  .mess_top {
    font-size: 12px;
    color: red;
    margin: 6px 0;
  }

  .group_stage {
    margin: 20px 0;
    line-height: 1.5;
  }

  .group_item {
    line-height: 1.5;
    margin-bottom: 12px;
  }

  .p_title {
    font-size: 18px;
    color: #333333;
  }

  .summary {
    font-size: 16px;
    color: #666666;
    margin: 2px 0;
  }

  .score_team .team {
    font-size: 14px;
    color: #333333;
  }

  .score_team .team:first-child input {
    margin-right: 20px;
  }

  .score_team .team:first-child {

  }

  .team .score_input {
    width: 70px;
    height: 30px;
    margin-left: 16px;
    line-height: 30px;
    text-align: center;
  }


</style>
